export const persistStorage = {
  getItemSafe: <T,>(key: string, defaultValue: T) => {
    const item = localStorage.getItem(key)
    return item === null ? defaultValue : JSON.parse(item)
  },

  setItemSafe: <T,>(key: string, value: T) => {
    return localStorage.setItem(key, JSON.stringify(value))
  },
  getItem: <T,>(key: string): T => {
    const item = localStorage.getItem(key)
    return item && JSON.parse(item)
  }
}
